import * as React from 'react'
import { CuttingSteps } from "./cuttingstepsview"
import { useContext } from "react"
import { AppContext } from "./appcontext"
import { SewingInst } from "./sewinginst"
import { Contact } from "./contactinfo"
import { Patterns } from "./patterns"
import { Routes, Route, useNavigate, useLocation } from "react-router-dom"

export function Instructions(props: {}) {

    const [subtitle, setSubtitle] = React.useState("")
    const location = useLocation();

    React.useEffect(() => {
        switch (location.pathname) {
            case "/howtosew/cut":
                setSubtitle(": How to Cut");
                break;
            case "/howtosew":
                setSubtitle(": How to Sew");
                break;
            case "/howtosew/patterns":
                setSubtitle(": Patterns");
                break;
            default:
                setSubtitle("")
        }
    })

    return <div className=" max-w-3xl m-auto landing p-4">
        <div style={{ fontFamily: 'Dancing Script' }} className="text-blue-500 text-5xl font-normal w-full text-center pb-6">Diaper Instructions{subtitle}</div>
        <Tabs />
        <Routes>
            <Route path="cut" element={<CuttingSteps />} />
            <Route path="patterns" element={<Patterns />} />
            <Route path="/*" element={<SewingInst />} />
        </Routes>

    </div>
}



function Tabs() {

    var ctx = useContext(AppContext)
    const navigate = useNavigate();
    const location = useLocation();


    return <div className="flex justify-around mb-2">
        <div onClick={e => navigate("cut")} className={`text-white px-2 py-1 rounded-md bg-blue-500 hover:bg-blue-700 hover:shadow-lg hover:shadow-blue-500 ${location.pathname == "/howtosew/cut" ? "bg-blue-600 border-white border-solid" : ""}`}>How to Cut</div>
        <div onClick={e => navigate("")} className={`text-white px-2 py-1 rounded-md bg-blue-500 hover:bg-blue-700  hover:shadow-lg hover:shadow-blue-500 ${location.pathname == "/howtosew" ? "bg-blue-600 border-white border-solid" : ""}`}>How to Sew</div>
        <div onClick={e => navigate("patterns")} className={`text-white px-2 py-1 rounded-md bg-blue-500 hover:bg-blue-700  hover:shadow-lg hover:shadow-blue-500 ${location.pathname == "/howtosew/patterns" ? "bg-blue-600 border-white border-solid" : ""}`}>Patterns</div>
    </div>
}